export interface AnimalMarker {
  id: string;
  nameKey: string;
  position: {
    lat: number;
    lng: number;
  };
  wanderRadius: number;
  image: string;
}

export const ANIMALS_MARKERS: AnimalMarker[] = [
  {
    id: "panda",
    nameKey: "animals.panda",
    position: { lat: -694.000625670818, lng: 778.9994846793261 },
    wanderRadius: 60,
    image: "/wild-animals/panda.webp",
  },
  {
    id: "capybara",
    nameKey: "animals.capybara",
    position: { lat: -186.750886366992, lng: 309.50128830168467 },
    wanderRadius: 50,
    image: "/wild-animals/capybara.webp",
  },
  {
    id: "rabbit",
    nameKey: "animals.rabbit",
    position: { lat: -537.5009385062268, lng: 356.25209349023754 },
    wanderRadius: 40,
    image: "/wild-animals/bunny.webp",
  },
  {
    id: "fox",
    nameKey: "animals.fox",
    position: { lat: -639.5004171138786, lng: 202.49903377373653 },
    wanderRadius: 70,
    image: "/wild-animals/fox.webp",
  },
  {
    id: "otter",
    nameKey: "animals.otter",
    position: { lat: -733.999374329182, lng: 508.749710132121 },
    wanderRadius: 40,
    image: "/wild-animals/sea-otter.webp",
  },
  {
    id: "mink",
    nameKey: "animals.mink",
    position: { lat: -341.2500521392348, lng: 280.00009662262636 },
    wanderRadius: 10,
    image: "/wild-animals/ferret.webp",
  },
  {
    id: "deer",
    nameKey: "animals.deer",
    position: { lat: -531, lng: 805 },
    wanderRadius: 60,
    image: "/wild-animals/silka-deer.webp",
  },
  {
    id: "llama",
    nameKey: "animals.llama",
    position: { lat: -691.2482794052507, lng: 238.50135271676885 },
    wanderRadius: 50,
    image: "/wild-animals/llama.webp",
  },
  {
    id: "penguin",
    nameKey: "animals.penguin",
    position: { lat: -143.75245054403678, lng: 460.7495813019525 },
    wanderRadius: 20,
    image: "/wild-animals/penguin.webp",
  },
];
